// Ikony rysowane w miejscu, w stylu Lucide: siatka 24, stroke 1.8, kolor
// dziedziczony z tekstu. Bez pakietu z ikonami - panel używa siedmiu sztuk
// i nie warto za to płacić kilkudziesięcioma kilobajtami w paczce.
//
// Ikona nigdy nie stoi sama: obok każdej jest etykieta albo aria-label.

import type { ReactNode } from "react";

function Glyph({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <svg
      aria-hidden
      focusable="false"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? "size-4 shrink-0"}
    >
      {children}
    </svg>
  );
}

export function ArrowLeftIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </Glyph>
  );
}

export function ChevronLeftIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="m15 18-6-6 6-6" />
    </Glyph>
  );
}

export function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="m9 18 6-6-6-6" />
    </Glyph>
  );
}

export function RetryIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="M21 12a9 9 0 1 1-2.64-6.36L21 8" />
      <path d="M21 3v5h-5" />
    </Glyph>
  );
}

export function SkipIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="M5 4l10 8-10 8z" />
      <path d="M19 5v14" />
    </Glyph>
  );
}

export function SendIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="M21 3 10.5 13.5" />
      <path d="M21 3l-6.5 18-4-8-8-4z" />
    </Glyph>
  );
}

export function DownloadIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="m7 10 5 5 5-5" />
      <path d="M12 15V3" />
    </Glyph>
  );
}

export function LogOutIcon({ className }: { className?: string }) {
  return (
    <Glyph className={className}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </Glyph>
  );
}
